module.exports = __webpack_public_path__ + "static/media/shakespeare_quotes.b97ee03f.png";